export const navbar = {
  Search: 'Search',
  SearchPlaceholder: 'What do you want to play?',
  Home: 'Home',
  'Your Library': 'Your Library',
  'Collapse your library': 'Collapse your library',
  'Expand your library': 'Expand your library',
  'Expand library view': 'Expand library view',
  'Shrink library view': 'Shrink library view',
  Language: 'Language',
  'Contact me': 'Contact me',
  Profile: 'Profile',
  Settings: 'Settings',
  'Log out': 'Log out',
  COMPACT: 'Compact',
  GRID: 'Grid',
  LIST: 'List',
  Playlists: 'Playlists',
  Artists: 'Artists',
  Composers: 'Composers',
  Albums: 'Albums',
  Works: 'Works',
  Recordings: 'Recordings',
  'Close search': 'Close search',
  LibrarySortDefault: 'Default order',
  LibrarySortRelevance: 'Relevance',
};
